import { Suspense, lazy } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from './components/theme-provider'
import { MainLayout } from './components/layout/MainLayout'
import HomePage from './pages/HomePage'

// Keep the landing page in the main bundle to avoid an extra network hop on first paint.
const CategoryPage = lazy(() => import('./pages/CategoryPage'))
const ItemPage = lazy(() => import('./pages/ItemPage'))

// Loading fallback components
const PageLoader = () => (
  <div className="flex-1 flex items-center justify-center p-20">
    <div className="w-10 h-10 border-4 border-primary/20 border-t-primary rounded-full animate-spin" />
  </div>
)

function App() {
  return (
    <ThemeProvider defaultTheme="system" enableSystem>
      <MainLayout>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/category/:slug" element={<CategoryPage />} />
            <Route path="/item/:slug" element={<ItemPage />} />
            {/* Fallback to Home for unknown routes */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </MainLayout>
    </ThemeProvider>
  )
}

export default App
